module.exports = __webpack_public_path__ + "static/media/ignition_authorised.c172f873.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/incident_layer/ignition_authorised.png
// module id = 368
// module chunks = 0